export const state = () => ({
  texts: {
    de: {
      showAll: 'Zeige alle',
      more: 'Mehr',
      showJobs: 'Jobs anzeigen',
      hideJobs: 'Jobs verstecken',
      all: 'Alle',
      article: 'Artikel',
      event: 'Event',
      'fact sheet': 'Fakten Sheet',
      'case study': 'Case study',
      video: 'Video',
      whitepaper: 'Whitepaper',
      author: 'Autor',
      authors: 'Autoren',
      type: 'Artikeltyp',
      audience: 'Audience',
      service: 'Services',
      technology: 'Technologie',
      topic: 'Themen'
    },
    en: {
      showAll: 'Show all',
      more: 'More',
      showJobs: 'Show jobs',
      hideJobs: 'Hide jobs',
      article: 'Article',
      event: 'Event',
      'fact sheet': 'Fact sheet',
      'case study': 'Case study',
      video: 'Video',
      whitepaper: 'Whitepaper',
      type: 'Content type',
      audience: 'Audience',
      author: 'Author',
      authors: 'Authors',
      service: 'Services',
      technology: 'Technology',
      topic: 'Topics'
    }
  }
})
export const getters = {
  texts(state) {
    return state.texts
  }
}
export const mutations = {}
export const actions = {}
